import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

export interface WhatsAppCampaignRequest {
  headerMedia?: File;
  headerType: string;
  paraCount: number;
  paras: string[];
  userListExcel?: File;
  campaignName: string;
}

export interface WhatsAppCampaignResponse {
  success: boolean;
  message?: string;
  data?: any;
}

@Injectable({
  providedIn: "root",
})
export class WhatsAppService {
  private whatsappUrl = environment.host + "whatsapp/";

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem("guestToken");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  createWhatsAppTemplate(formData: FormData): Observable<WhatsAppCampaignResponse> {
    const headers = this.getAuthHeaders();
    return this.http.post<WhatsAppCampaignResponse>(
      this.whatsappUrl + "create-whatsapp-template",
      formData,
      { headers }
    );
  }

  createWhatsAppCampaign(formData: FormData): Observable<WhatsAppCampaignResponse> {
    const headers = this.getAuthHeaders();
    return this.http.post<WhatsAppCampaignResponse>(
      this.whatsappUrl + "create-whatsapp-campaign",
      formData,
      { headers }
    );
  }

  getCampaignHistory(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(this.whatsappUrl + "campaign-history", { headers });
  }

  getSavedTemplates(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(this.whatsappUrl + "templates", { headers });
  }

  getUsedTemplates(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(this.whatsappUrl + "used-templates", { headers });
  }

  deleteTemplate(templateId: string): Observable<any> {
    const headers = this.getAuthHeaders();
    const body = { templateId };
    return this.http.patch(this.whatsappUrl + "delete-template", body, { headers });
  }

  getCampaigns(page: number = 1, limit: number = 10): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(this.whatsappUrl + "campaigns?page=" + page + "&limit=" + limit, { headers });
  }

  getCampaignUsers(campaignId: string): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(this.whatsappUrl + "campaign-users?campaignId=" + campaignId, { headers });
  }

  getIncomingMessages(page: number = 1, limit: number = 10, startDate?: string, endDate?: string): Observable<any> {
    const headers = this.getAuthHeaders();
    let url = this.whatsappUrl + "incoming-whatsapp-message-phone-numbers?page=" + page + "&limit=" + limit;
    if (startDate) {
      url += "&startDate=" + startDate;
    }
    if (endDate) {
      url += "&endDate=" + endDate;
    }
    return this.http.get(url, { headers });
  }

  getMessagesByPhoneNumber(phoneNumber: string, page: number = 1, limit: number = 20, startDate?: string, endDate?: string): Observable<any> {
    const headers = this.getAuthHeaders();
    let url = this.whatsappUrl + "incoming-whatsapp-messages?page=" + page + "&limit=" + limit + "&phoneNumber=" + phoneNumber;
    if (startDate) {
      url += "&startDate=" + startDate;
    }
    if (endDate) {
      url += "&endDate=" + endDate;
    }
    return this.http.get(url, { headers });
  }
}
